import { useQuery } from '@tanstack/react-query';
import type { AdGraphQueryDto } from '@terra/shared-contracts-internal-network';
import { terraProxyApiClient } from '../../clients/testerClient';

export const INTERNAL_NETWORK_GRAPH_KEY = 'internal-network-graph';

const INTERNAL_NETWORK_STALE_TIME_MS = 30_000;

export function useInternalNetworkGraph({
  networkId,
  queryParams = { mode: 'full' },
  options = {},
}: {
  networkId: string | null;
  queryParams?: AdGraphQueryDto;
  options?: { enabled?: boolean };
}) {
  const graphQuery = useQuery({
    queryKey: [INTERNAL_NETWORK_GRAPH_KEY, networkId, queryParams],
    queryFn: () =>
      terraProxyApiClient.getInternalNetworkGraph(networkId ?? '', queryParams),
    enabled: Boolean(networkId) && (options.enabled ?? true),
    staleTime: INTERNAL_NETWORK_STALE_TIME_MS,
  });

  return {
    graph: graphQuery.data,
    isLoading: graphQuery.isLoading,
    isError: graphQuery.isError,
    refetch: graphQuery.refetch,
  };
}
